import React from 'react';

const ABOUTME = () => {
    return (
        <>
            
                <div className="about-me pt-4 pt-md-0">
                    <div className="title-box-2">
                        <h5 className="title-left">
                        About me
                        </h5>
                    </div>
                    <p className="lead">
                        I am currently in high school and I am currently self-studying computer programming.
                    </p>
                    <p className="lead">
                        I love to watch kdrama and anime.
                    </p>
                    <p className="lead">
                        I want to be a successful programmer someday.
                    </p>
                </div>
            
        </>
    )
}

export default ABOUTME;
